// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hr","advertCardPhoto__image":"c-a_hs"};